export default __webpack_public_path__ + "static/media/oracle.08e693a88040ba3c5069ef723b0d3e6c.svg";